import { useContext, useEffect, useRef, useState } from "react";
import { convertToApproximateString, convertToFloat, convertToString, modifyString } from "./convert";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { IconButton } from "@mui/material";

const MoneyInput = ({ value, onChange, undervalue, uppervalue, ...props }) => {
    const [stringValue, setStringValue] = useState(convertToString(value) || "0");
    const [firstValue, setFirstValue] = useState(convertToString(value) || "0");

    useEffect(() => {
        // Update stringValue when props.value changes, avoiding redundant updates
        if (convertToFloat(stringValue) !== value) {
            setStringValue(convertToString(value) || "0");
            setFirstValue(convertToString(value) || "0");
        }
    }, [value]);

    const handleInputChange = (e) => {
        const inputValue = e.target.value.split(",").join("");
        const floatValue = convertToFloat(inputValue);

        // Update states and notify parent only if values change
        setStringValue(modifyString(inputValue) || "0");
        if (floatValue !== value) {
            onChange(floatValue); // Notify parent
        }
    };

    const resetRate = () => {
        setStringValue(convertToString(firstValue) || "0");
    };

    return (
        <div
            style={{
                position: "relative",
                marginRight: window.innerWidth <= 650 ? "" : "20px",
                marginTop: window.innerWidth <= 650 ? "30px" : "",
            }}
        >
            <p style={{ paddingLeft: "5px", color: "white" }}>{uppervalue ? uppervalue : ""}</p>
            {props.label && (
                <p
                    style={{
                        color: "white",
                        width: "100%",
                        position: "absolute",
                        fontSize: "12px",
                        display: "inline-block",
                        lineHeight: "25px",
                        textAlign: "left",
                        padding: "0 8px",
                        marginTop: "-25px",
                    }}
                >
                    {props.label ? props.label : ""}
                </p>
            )}
            {uppervalue === "Rate to add" ? (
                <div style={{ position: "relative", width: "100%" }}>
                    <input
                        {...props}
                        value={stringValue}
                        onChange={handleInputChange}
                        className="form-input flex w-full w-[80vw] mt-2 sm:mt-0 min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                    />
                    <IconButton
                        onClick={resetRate}
                        sx={{
                            position: "absolute",
                            left: window.innerWidth <= 650 ? "70%" : "130px",
                            top: "50%",
                            width: window.innerWidth <= 650 ? "10px" : "50px",
                            minWidth: window.innerWidth <= 650 ? "60px" : "auto",
                            transform: "translateY(-50%)",
                            backgroundColor: "#FEC901",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            padding: "8px 12px",
                            cursor: "pointer",

                            "&:hover": {
                                backgroundColor: "black", // Darker shade for hover
                            },
                        }}
                    >
                        <RestartAltIcon
                            sx={{
                                color: "black",
                                "&:hover": {
                                    color: "white", // Darker shade for hover
                                },
                            }}
                        />
                    </IconButton>
                </div>
            ) : (
                <input
                    {...props}
                    value={stringValue}
                    onChange={handleInputChange}
                    className="form-input flex w-full w-[80vw] mt-2 sm:mt-0 min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                />
            )}
            <p
                style={{
                    color: "white",
                    width: "100%",
                    position: "absolute",
                    fontSize: "12px",
                    display: "inline-block",
                    lineHeight: "25px",
                    textAlign: "right",
                }}
            >
                {undervalue && (convertToApproximateString(undervalue ? undervalue.value : 0) || "0")} {undervalue && `${undervalue?.currency_name}(${convertToApproximateString(undervalue?.avg)})`}
            </p>
        </div>
    );
};

export default MoneyInput;
